import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./home";
import { useAuth0 } from "@auth0/auth0-react";
import NotFound from "./not-found";
import Layout from "../components/layout";
import Profile from "./profile";
import Tranference from "./tranference";
import Users from "./users";
import Transaction from "./transaction";
import Developers from "./developers";
import Withdrawals from "./withdrawal";
import BankTransfer from "./transfer";
import CanceledTransaction from "./canceled-transaction";
import { BlackListCard } from "./blackListCard";

const AppRoutes: React.FC = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="page-layout">
        cargando....
        {/* <PageLoader /> */}
      </div>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/api" element={<Profile />} />
        <Route path="/users" element={<Users />} />
        <Route path="/transactions" element={<Transaction />} />
        <Route path="/withdrawals" element={<Withdrawals />} />
        <Route path='/transferencias-bancarias' element={<BankTransfer/>}/>
        <Route path = '/contracargos' element={<CanceledTransaction/>}/>
        <Route path="/developers" element={<Developers/>} />
        <Route path="/tarjetas" element={<BlackListCard/>}/>
      </Routes>
    </Layout>
  );
};

export default AppRoutes;
